import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { PROTOCOLS } from "../lib/protocols";
import {
  PHONE_OFFICE,
  PHONE_FOUNDER,
  EMAIL_DIREZIONE,
  EMAIL_ALESSIO,
  EMAIL_PEC,
  INSTAGRAM_URL,
  PORTAL_URL,
  EDILIZIA_URL,
} from "../lib/api";
import { useSectionNavigation, useActiveSection } from "../lib/navigation";

const SECTION_LINKS = ["obiettivi", "metodo", "compensi", "protocolli", "impresa-partner", "piattaforma", "assistente", "ecosistema", "chi-siamo", "contatti"];

export default function Footer() {
  const goToSection = useSectionNavigation();
  const active = useActiveSection(SECTION_LINKS);

  return (
    <footer className="border-t border-[#c9a45c]/25 bg-[#070707]" data-testid="site-footer">
      <div className="container-hub py-12 md:py-14">
        <div className="grid grid-cols-1 gap-9 md:grid-cols-3 md:gap-10">
          <div>
            <Logo />
            <p className="mt-5 max-w-[300px] text-[11px] uppercase leading-[1.9] tracking-[0.16em] text-[#c9c6bf]">
              Real Estate Advisory — consulenza immobiliare di parte. Referente unico: partner selezionati con te, portale digitale riservato. Non devi coordinare il mondo immobiliare: lo facciamo noi.
            </p>
            <a
              href={PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-portal-link"
              className="btn btn-outline mt-6 !min-h-[40px] !px-4 !text-[9px]"
            >
              Portale digitale
            </a>
          </div>

          <div className="border-t border-[#c9a45c]/12 pt-8 md:border-0 md:pt-0">
            <p className="mb-4 text-[9px] font-bold tracking-[0.25em] text-gold">SEZIONI</p>
            <div className="flex flex-wrap gap-x-5 gap-y-3">
              {SECTION_LINKS.map((id) => (
                <a
                  key={id}
                  href={`/#${id}`}
                  data-testid={`footer-link-${id}`}
                  data-active={active === id || undefined}
                  onClick={(e) => {
                    e.preventDefault();
                    goToSection(id);
                  }}
                  className={`text-[10px] uppercase tracking-[0.14em] transition-colors duration-200 ${
                    active === id
                      ? "text-gold-light underline decoration-gold-light/60 underline-offset-4"
                      : "text-[#bbb8b0] hover:text-gold-light"
                  }`}
                >
                  {id.replace("-", " ")}
                </a>
              ))}
            </div>
            <p className="mb-4 mt-6 text-[9px] font-bold tracking-[0.25em] text-gold">PROTOCOLLI</p>
            <div className="flex flex-wrap gap-x-5 gap-y-3">
              {PROTOCOLS.map((p) => (
                <Link
                  key={p.slug}
                  to={`/protocollo/${p.slug}`}
                  data-testid={`footer-protocol-${p.slug}`}
                  className="text-[10px] uppercase tracking-[0.14em] text-[#bbb8b0] transition-colors hover:text-gold-light"
                >
                  {p.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid gap-2.5 border-t border-[#c9a45c]/12 pt-8 text-[11px] text-[#bbb8b0] md:border-0 md:pt-0">
            <p className="mb-2 text-[9px] font-bold tracking-[0.25em] text-gold">CONTATTI</p>
            <a href={PHONE_OFFICE} data-testid="footer-phone-office" className="transition-colors hover:text-gold-light">
              Ufficio: 351 4129152
            </a>
            <a href={PHONE_FOUNDER} data-testid="footer-phone-founder" className="transition-colors hover:text-gold-light">
              Alessio Cannino: 327 1757953
            </a>
            <a href={`mailto:${EMAIL_DIREZIONE}`} data-testid="footer-email-direction" className="transition-colors hover:text-gold-light">
              {EMAIL_DIREZIONE}
            </a>
            <a href={`mailto:${EMAIL_ALESSIO}`} data-testid="footer-email-alessio" className="transition-colors hover:text-gold-light">
              {EMAIL_ALESSIO}
            </a>
            <a href={`mailto:${EMAIL_PEC}`} data-testid="footer-pec" className="transition-colors hover:text-gold-light">
              PEC: {EMAIL_PEC}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="transition-colors hover:text-gold-light">
              Instagram: @alessiocannino.realestate
            </a>
            <a href={EDILIZIA_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-edilizia" className="transition-colors hover:text-gold-light">
              Edilizia Cannino
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-[#c9a45c]/14 pt-5 text-[10px] leading-relaxed text-[#777]">
          <span data-testid="footer-legal" className="max-w-[720px]">
            A.C. HUB di Alessio Cannino · Sede legale: via Fratelli Rosselli 3, Molinella (BO) · Operatività: Modena, Bologna, Ferrara · P.IVA: 04219381201 · PEC: direzione@pec.achubimmobiliare.it
          </span>
          <span data-testid="footer-rights">Privacy · Cookie · Note legali · © {new Date().getFullYear()} A.C. HUB — Real Estate Advisory</span>
        </div>
      </div>
    </footer>
  );
}
